import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="checkbox"
export default class extends Controller {
  connect() {
    console.log("Checkbox controller connected");
  }

  toggleCheckAll(event) {
    const checked = event.target.checked;
    this.element
      .querySelectorAll("[name*=_ids]")
      .forEach((checkbox) => (checkbox.checked = checked));
  }
}
